// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U9).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { DeleteAccount } from '../../features/account/DeleteAccount'
import { meQuery } from '../../shared/org/me'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/account/delete')({
  staticData: { screenId: 'AccountDeleteScreen', access: 'signed in (demo: End demo instead)' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: AccountDeleteScreen,
})

function AccountDeleteScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid={ids.accountDelete.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('account.delete.title')}>
        <p className="text-fg-muted">{t('account.delete.lede')}</p>
      </PageHeader>
      <Part testId={ids.accountDelete.skeleton}>
        <DeleteAccount />
      </Part>
    </main>
  )
}
